import { render, staticRenderFns } from "./MineActivity.vue?vue&type=template&id=5d1b0873"
import script from "./MineActivity.vue?vue&type=script&lang=js"
export * from "./MineActivity.vue?vue&type=script&lang=js"
import style0 from "./MineActivity.vue?vue&type=style&index=0&id=5d1b0873&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports